module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/rever/logo-r-red@2x.png"